<!--
  @author 19185247 刘云飞
  @description 原订单详情流程不变，为降低业务耦合度，分别独立开发
  @date 2020-10-09
-->
<template>
  <ys-detail v-if="isYSOrder" />
  <default-detail v-else />
</template>
<script>
import { pageReloadInIOS12 } from '@/utils'
import defaultDetail from './detail/default'
import ysDetail from './detail/ys'
export default {
  data() {
    return {
      isYSOrder: !!+this.$route.query.isys
    }
  },
  components: {
    defaultDetail,
    ysDetail
  },
  created() {
    // pageReloadInIOS12()
  },
  provide() {
    return {
      /* 订单详情页面埋点参数 */
      detailTrackParams: {
        bizType: '127',
        pageLevelId: '121013096'
      },
      /* 拨打电话事件埋点参数 */
      busiTelTrackParams: {
        bizType: '127',
        pageLevelId: '121013096',
        clickId: '200002'
      },
      /* 申请售后事件埋点参数 */
      servTelTrackParams: {
        bizType: '127',
        pageLevelId: '121013096',
        clickId: '200003',
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      },
      /* 核销码左右滑动事件埋点参数 */
      barcodeTrackParams: {
        bizType: '127',
        pageLevelId: '121013096',
        clickId: '200001'
      },
      /** 我的相册点击事件埋点参数 */
      myAlbumTrackParams: {
        bizType: '127',
        pageLevelId: '121013096',
        clickId: '200006'
      }
    }
  }
}
</script>
